export default {"src":"/_next/static/media/Search.28d3f6a4.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};